import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningRequestsService} from "../../services/planning-requests.service";

export class PlanningTemplatesView implements IController {
  templates: any;

  /* @ngInject */
  constructor(private $log, private $state, private planningDialogService: PlanningDialogService, private planningRequestsService: PlanningRequestsService, private bringozLoaderService: BringozLoaderService, private planningAlertsService: PlanningAlertsService) {

  }

  /////////////////////////////////////////
  ////////////  Public Methods  /////////
  /////////////////////////////////////////
  onCreateTemplate(event) {
    this.planningDialogService.createTemplate(event)
      .then((template) => {
        this.createTemplate(template);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDeleteTemplate(templateId) {
    this.bringozLoaderService.on();
    this.planningRequestsService.deleteTemplate(templateId)
      .then(() => {
        this.templates = _.filter(this.templates, (t) => {
          return t.id !== templateId;
        });
        this.planningAlertsService.deleteTemplateSuccess();
      })
      .catch(() => {
        this.planningAlertsService.deleteTemplateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  /////////////////////////////////////////
  ////////////  Private Methods  /////////
  /////////////////////////////////////////

  private createTemplate(template) {
    this.bringozLoaderService.on();
    this.planningRequestsService.createTemplate(template)
      .then((createdTemplate) => {
        this.planningAlertsService.createTemplateSuccess();
        this.$state.go('planning.template', {id: createdTemplate.id});
      })
      .catch(() => {
        this.planningAlertsService.createTemplateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningTemplatesView', {
    bindings: {
      templates: '<'
    },
    template: require('./planning-templates-view.html').default,
    controller: PlanningTemplatesView
  });
